	import axios from 'axios'
	import Qs from 'qs';
	import router from '../router/index.js'
	import {removeToken,navTo} from '../utils/utils'
	
	// 环境的切换
	if (process.env.NODE_ENV == 'development') {    
		// axios.defaults.baseURL = 'http://test-biz.qiyuesw.net';
		axios.defaults.baseURL = 'https://biz.zhangwen.cn';
	}else if (process.env.NODE_ENV == 'production') {    
		// axios.defaults.baseURL = 'http://test-biz.qiyuesw.net';
		axios.defaults.baseURL = 'https://biz.zhangwen.cn';
	}

	const service = axios.create({
		 // API 请求的默认前缀
		 baseURL: process.env.VUE_APP_API_BASE_URL,
		 // baseURL: '/api',
		 timeout: 30000, // 请求超时时间
		 withCredentials: true,
	})
  	// 2.axios的拦截器
  	service.interceptors.request.use(
	  (config) => {
		// 需要token的接口
		let needToken = [
			'/comic/enjoyRead/getPageList',//收藏记录
			'/comic/recentRead/getPageList',//历史记录
			'/comic/gear/get',//获取档位接口
			'/comic/order/create',//创建订单
			'/comic/order/find',//查询订单状态
			'/comic/recharge/find',//查询充值记录
			'/comic/recharge/remain',//查询用户余额
			'/comic/recentRead/getPageList',//观看历史
			'/comic/enjoyRead/getPageList',//收藏列表
			'/comic/unlockComic/unlockList',//查询消费记录
		]

		//设置请求头
		config.headers["Content-Type"] = "application/json;charset=UTF-8";
		config.headers["Access-Control-Allow-Credentials"] = true;
		// // 需要登录的接口  若未登录->跳转到登录页
		// if (getToken()) { //判断本地缓存的token是否存在
		// 	config.headers['cToken'] = getToken()
		// }
		// if(needToken.some(item=>item == config.url && !getToken())){
		// 	navTo('/login',{msg:'请先登录~'})
		// 	return Promise.reject('请先登录~')
		// }
		  
		return config
	  },
	  (error) => { //token不存在，设置为网络报错
		  return Promise.reject(error)
	  }
  	)
  // 2.2.响应拦截
  	service.interceptors.response.use(
	  (res) => { //响应处理
		  if (res.status === 200) { //响应码200请求成功
			//接口请求成功 
			// 200为成功
			// 1002为登录接口验证码错误
			// 2001为章节解锁有误  重复或未解锁或其他
			// 400为参数错误
			  if (res.data.code == '200' || res.data.code == '1002'|| res.data.code == '2001' ) { 
				  return Promise.resolve(res.data)
			  } else if (res.data.code == '401' || res.data.code == '4010') {//token验证失败，根据自己实际的修改
				  //清除token
				//   removeToken()
				  //跳转到登录页面
				  navTo('/login',{msg:'请先登录~'})
				//   localStorage.removeItem('Authorization')
				  return Promise.reject(res.data)
			  } else {
				  //Message.error(res.data.msg);
				  return Promise.reject(res.data)
			  }
		  } else {
			  return Promise.reject(res.data)
		  }
		  // return res
	  },
	  (error) => {
		  if (error && error?.status === 401) {
			//   Message.error('请重新登录')
			  //清楚token
			//   removeToken()
			  navTo('/login',{msg:'请先登录~'})
			//   localStorage.removeItem('Authorization')
			//   跳转到登录页面
			//   router.push('/login')
		  }
		  return Promise.reject(error ? error : '网络错误！')
	  }
  )
	/**
	 * get 请求方法
	 * @param url
	 * @param params
	 * @returns {Promise}
	 */
	export function get(url, params = {}) {
		return new Promise((resolve, reject) => {
			service.get(url, {
					params: params
				})
				.then(response => {
					if(response.code == 200 ){
						resolve(response)
					}else{
						reject(response)
					}
				})
				.catch(err => {
					reject(err)
				})
		})
	}

	/**
	 * post 请求方法
	 * @param url
	 * @param data
	 * @returns {Promise}
	 */
	export function post(url, data) {
		return new Promise((resolve, reject) => {
			service.post(url,JSON.stringify(data)).then(response => {
				if(response.code == 200 ){
					resolve(response)
				}else{
					reject(response)
				}
			})
			.catch(err => {
				reject(err)
			})
		})
	}